import { Button, Link } from "@mui/material";
import React from "react";
import {
  useDispatchWrapper,
} from "../../../../../../../hooks";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../../redux/initialStoreState";
import { LoadState } from "../../../../../../../constants/enums";


import { AddOutlined } from "@mui/icons-material";
import { StandardTableActions } from "../../../../../../../components/StandardTableActions/StandardTableActions";
import { LifeInsuranceAddClaimDialog } from "./AddClaimDialog";
import { ViewLifeInsurerClaimDialog } from "./ViewClaimDialog";
import { addLifeInsuranceClaimAsync, fetchLifeInsuranceClaimsAsync } from "../../../../../../../redux/lifeInsurancePolicy/lifeInsuranceBasicDetail/lifeInsuranceBasicDetailActions";
import { ILifeInsuranceClaims } from "../../../../../../../redux/lifeInsurancePolicy/lifeInsuranceBasicDetail/lifeInsuranceBasicDetail.types";
import { StatusRenderer } from "../../../../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { useOutletContext } from "react-router-dom";
import { useTableV2State } from "../../../../../../../components/TableV2/hooks/useTableV2State";
import { DataTableV2RowRenderType, IDataTableV2Props } from "../../../../../../../components/TableV2/interfaces/IDataTableV2Props";
import { ControlledCustomSelect } from "../../../../../../../components/formsComponents/CustomSelect";
import { PageContainer } from "../../../../../../../components/container/PageContainer";
import { PageTitleBar } from "../../../../../../../components/PageTitleBar/PageTitleBar";
import { DataTableV2 } from "../../../../../../../components/TableV2/DataTableV2";
import { ConfirmDialog } from "../../../../../../../components/Dialogs/ConfirmDialog";

const INITIAL_STATE = {
  customer_policy_id: 0,
  serial_number: 0,
  claim_number: null,
  date_of_loss: null,
  risk_location: null,
  amount_paid_dollar: null,
  ours: null,
  type: null,
  producer: null,
  branch: null,
  amount_paid: null,
  loss_details: null,
  status: null,
};

export const LifeInsurerClaim: React.FC = () => {
  const data2 = useOutletContext() as any;
  const customerId = data2[0];
  const customerpolicyId = data2[1];
  const { data, Loading } = useSelector(
    (storeState: IStoreState) => storeState.lifeInsurance.basicDetails.claim
  );
  const [openClaim, setOpenClaim] = React.useState<ILifeInsuranceClaims | null>(
    null
  );
  const [openView, setOpenView] = React.useState<ILifeInsuranceClaims | null>(
    null
  );
  const [deleteConfirm, setDeleteConfirm] = React.useState<ILifeInsuranceClaims | null>(null);
  const dispatch = useDispatchWrapper();
  const [status, setStatus] = React.useState<"Open" | "Closed" | "Re-opened" >(
    "Open"
  );

  const {
    state: { dateState, searchState, tabs, columnsConfig, dense },
    setDateState,
    setSelectedTab,
    setTableTabs,
    setSearchState,
    setColumnVisibility,

    onDenseToggle,
  } = useTableV2State({
    filtersInitialState: {
      defaultDateRange: "allTimes",
      selectedTab: "-1",
    },
  });
  const fetchList = () => {
    if (customerpolicyId) {
      dispatch(fetchLifeInsuranceClaimsAsync(customerpolicyId, status));
    }
  };

  const handleDelete = () => {
    if (deleteConfirm) {
      dispatch(
        addLifeInsuranceClaimAsync(
          { ...deleteConfirm, status: "INACTIVE" },
          (isSuccess) => {
            if (isSuccess) {
              fetchList();
            }
            setDeleteConfirm(null);
          }
        )
      );
    }
  };

  React.useEffect(() => {
    
    fetchList();
  
}, [customerpolicyId, status]);


  const claimTableProps: IDataTableV2Props = {
    isPagination: false,
    isDataLoading: Loading === LoadState.InProgress,
    tableCommandBarProps: {
      preDefinedPlugins: {
        columnVisibility: {
          columnVisibility: columnsConfig.columnVisibility,
          onChange: setColumnVisibility,
        },
        refresh: {
          onClick: fetchList,
        },
      },
      leftItems: {},
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <ControlledCustomSelect
                fullWidth
                value={status}
                name="status"
                onChange={(e) => setStatus(e.target.value as "Open")}
                placeholder="Select one"
                displayEmpty
                options={[
                  { label: "Open", value: "Open" },
                  { label: "Closed", value: "Closed" },
                  { label: "Re-opened", value: "Re-opened" },
                ]}
              />
              // <Button
              //   variant="contained"
              //   onClick={() =>
              //     setOpenClaim({
              //       ...INITIAL_STATE,
              //       customer_policy_id: customerpolicyId,
              //     })
              //   }
              // >
              //   Add New Claim
              // </Button>
            ),
          },
        ],
      },
    },
   
    masterColumns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        isFirstColumnSticky: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ILifeInsuranceClaims) => {
          return (
            <StandardTableActions
              onViewClick={() => setOpenView(row)}
              onEditClick={() => setOpenClaim(row)}
              onDeleteClick={() => setDeleteConfirm(row)}
              // more={{ menuItems: menuItems }}
            />
          );
        },
      },
      {
        key: "serial_number",
        headerName: "#",
        fieldName: "serial_number",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        enableSorting: true,
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (values, row) => {
          return <StatusRenderer status={row.status} />;
        },
      },
      {
        key: "claim_number",
        headerName: "Claim Number",
        fieldName: "claim_number",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        enableSorting: true,
        onRowCellRender: (value, row: ILifeInsuranceClaims) => {
          return (
            <Link sx={{ cursor: "pointer" }} onClick={() => setOpenClaim(row)}>
              {row.claim_number}
            </Link>
          );
        },
      },

      {
        key: "date_of_loss",
        headerName: "Date of Loss",
        fieldName: "date_of_loss",
        renderType: DataTableV2RowRenderType.DATE,
        enableSorting: true,
      },
      {
        key: "branch",
        headerName: "Branch",
        fieldName: "branch",
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "producer",
        headerName: "Producer",
        fieldName: "producer",
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "amount_paid_dollar",
        headerName: "Amount Paid ($)",
        fieldName: "amount_paid_dollar",
        renderType: DataTableV2RowRenderType.TEXT,
      },

      {
        key: "loss_details",
        headerName: "Loss Details",
        fieldName: "loss_details",
        renderType: DataTableV2RowRenderType.TEXT,
      },

     
    ],
    rows: data || [],
  };

 
  return (
    <PageContainer title="Claims" description="this is inner page">
      <PageTitleBar heading="Claims"
        rightHeading={
          <Button
            variant="contained"
            onClick={() => setOpenClaim({ ...INITIAL_STATE, customer_policy_id: customerpolicyId })}
            startIcon={<AddOutlined />}
          >
            Create
          </Button>
        }
      />
      <DataTableV2 {...claimTableProps} />
      {openClaim && (
        <LifeInsuranceAddClaimDialog
          open={true}
          claim={openClaim}
          onClose={() => setOpenClaim(null)}
        />
      )}
      {openView && (
        <ViewLifeInsurerClaimDialog
          open={true}
          claim={openView}
          onClose={() => setOpenView(null)}
        />
      )}
      {deleteConfirm && (
        <ConfirmDialog
          open={true}
          content="Are you sure you want to delete this claim?"
          onConfrim={handleDelete}
          onClose={() => setDeleteConfirm(null)}
        />
      )}
    </PageContainer>
  );
};
